import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
  connect(){
    console.log(`${this.identifier} is connected`)
    this.element.querySelector('.dropdown-trigger button').addEventListener('click', (evt) => {
      evt.target.closest('.dropdown').classList.toggle('is-active')
    })
  }
}